import React from "react";

const money = value => new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
}).format(Number(value || 0));

export function bindingDeadlineIsActive(now = new Date()) {
  const current = now instanceof Date ? now : new Date(now);
  return Number.isFinite(current.getTime()) && current.getTime() >= Date.parse("2026-11-01T00:00:00-03:00");
}

export function bindingRemainingLabel(minutes) {
  const total = Math.max(0, Math.floor(Number(minutes) || 0));
  const hours = Math.floor(total / 60);
  const remainder = total % 60;
  if (hours && remainder) return `${hours}h ${remainder}min`;
  if (hours) return `${hours}h`;
  return `${remainder}min`;
}

export default function BindingDeadlineNotice({ sale, onOpen }) {
  const deadline = sale?.bindingDeadline;
  if (!deadline?.eligible || !bindingDeadlineIsActive() || !["pending", "overdue"].includes(deadline.state)) return null;

  const pedido = sale.liftPedidoId ?? sale.pedido;
  const amount = sale.valorTotal ?? sale.valor;
  const cardStyle = {
    marginTop: 10,
    padding: "10px 12px",
    border: "1px solid #F2B8B5",
    borderLeft: "4px solid #B42318",
    borderRadius: 6,
    background: "#FFF7F5",
    color: "#57201C",
    fontSize: 13,
  };
  const overdue = deadline.state === "overdue";
  const applied = overdue && deadline.initialApplied === true && deadline.incomplete !== true;

  return (
    <div aria-label={`Prazo para vincular venda ${pedido}`} style={cardStyle}>
      <div style={{ fontWeight: 800 }}>{`Vincular venda #${pedido} · ${money(amount)}`}</div>
      {overdue ? (
        <div style={{ marginTop: 4, color: "#8F1D17", fontWeight: 700 }}>
          {applied
            ? "−30 aplicados · Vincule ou perderá 10 pontos por dia parado"
            : "Prazo vencido · Apuração do desconto pendente"}
          {applied && (
            <div style={{ marginTop: 3, fontWeight: 600 }}>
              {`${Number(deadline.dailyDays || 0)} ${Number(deadline.dailyDays) === 1 ? "dia" : "dias"} parado · ${Number(deadline.penaltyPoints || 0)} pontos perdidos`}
            </div>
          )}
          {deadline.incomplete && <div style={{ marginTop: 3, fontWeight: 500 }}>Vínculo ainda incompleto.</div>}
        </div>
      ) : (
        <div style={{ marginTop: 4, color: "#A51D18", fontWeight: 700 }}>
          {`Perde 30 pontos · Restam ${bindingRemainingLabel(deadline.remainingMinutes)}`}
        </div>
      )}
      {!overdue && deadline.warning30 && (
        <div role="status" style={{ marginTop: 4, color: "#8F1D17", fontWeight: 700 }}>
          Atenção: faltam 30 minutos ou menos para vincular esta venda.
        </div>
      )}
      {onOpen && (
        <button type="button" onClick={() => onOpen(sale)} style={{
          marginTop: 7, padding: "5px 9px", border: "1px solid #B42318",
          borderRadius: 4, background: "#fff", color: "#8F1D17",
          cursor: "pointer", font: "inherit", fontWeight: 700,
        }}>
          Abrir em Lembretes
        </button>
      )}
    </div>
  );
}
